import BaseSetup from '@/components/BaseSetup';
import useBusService from '@/services/BusService';
import useTalentPoolService from '@/services/TalentPoolService';
import { Reactive } from '@/utils/decorators';
import { useNotif } from '@orion.ui/orion';

export type SharedOrderGroupSelectEmits = {};

export type SharedOrderGroupSelectProps = {
	value?: number[]
	candidateId: number
};

export default class SharedOrderGroupSelectSetup extends BaseSetup {

	static readonly defaultProps = { value: () => [] };

	@Reactive private readonly state = {
		groupOptions: [] as ITalentPoolForProfileModel[],
		groups: [] as ITalentPoolForProfileModel[],
	};

	get groupOptions () { return this.state.groupOptions }

	get groups () { return this.state.groups }
	set groups (val) { this.state.groups = val }

	constructor (
		private props: SharedOrderGroupSelectProps,
		private emits: SharedOrderGroupSelectEmits,
	) {
		super();
	}

	protected override async onBeforeMountAsync (): Promise<void> {
		await this.getTalentPoolAsync();
	}

	private async getTalentPoolAsync () {
		this.state.groupOptions = await useTalentPoolService().listAsync();
		this.state.groups = (this.props.value ?? []).map((id: number) => ({
			id,
			label: this.state.groupOptions.findByKey(id, 'id')?.label,
		}));
	}

	async addGroupAsync (talentPool: ITalentPoolForProfileModel) {
		await useTalentPoolService().addTalentAsync(talentPool.id, { userIds: [this.props.candidateId] });

		[this.props.candidateId].forEach((userId) => {
			useBusService().emit(`addTalentPool:${userId}`, talentPool);
		});

		useNotif.success(this.$t('business.talentPool.candidateAdded', { label: talentPool.label }));
	}

	async removeGroupAsync (talentPool: ITalentPoolForProfileModel) {
		await useTalentPoolService().deleteTalentAsync(talentPool.id, this.props.candidateId);

		[this.props.candidateId].forEach((userId) => {
			useBusService().emit(`removeTalentPool:${userId}`, talentPool);
		});

		useNotif.success(this.$t('business.talentPool.candidateRemoved', { talentPool }));
	}

}
